import { render, staticRenderFns } from "./DashboardInfoWidgets.vue?vue&type=template&id=7cc2ec90&scoped=true"
import script from "./DashboardInfoWidgets.vue?vue&type=script&lang=js"
export * from "./DashboardInfoWidgets.vue?vue&type=script&lang=js"
import style0 from "./DashboardInfoWidgets.vue?vue&type=style&index=0&id=7cc2ec90&lang=css"
import style1 from "./DashboardInfoWidgets.vue?vue&type=style&index=1&id=7cc2ec90&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7cc2ec90",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/pagsmile/front-end/pagsmile-dashboard/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7cc2ec90')) {
      api.createRecord('7cc2ec90', component.options)
    } else {
      api.reload('7cc2ec90', component.options)
    }
    module.hot.accept("./DashboardInfoWidgets.vue?vue&type=template&id=7cc2ec90&scoped=true", function () {
      api.rerender('7cc2ec90', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/dashboard/DashboardInfoWidgets.vue"
export default component.exports